import React from 'react';
import { useNetworkStatus } from '../hooks/useNetworkStatus';
import { WifiIcon, WifiOffIcon } from 'lucide-react';

export const NetworkStatusIndicator: React.FC = () => {
  const { isOnline } = useNetworkStatus();

  return (
    <div className="flex flex-row items-center gap-2 ml-2">     
      <div 
        className={`flex items-center px-3 py-1.5 rounded-md shadow-md ${
          isOnline ? 'bg-green-100 text-green-800 border border-green-300' : 'bg-red-100 text-red-800 border border-red-300'
        }`}
        title={isOnline ? 'Online' : 'Offline'}
        aria-label={isOnline ? 'Online status' : 'Offline status'}
        data-testid="network-indicator"
      >
        {isOnline ? (
          <>
            <WifiIcon size={16}/>
            <span className="font-medium hidden md:inline ml-1.5">Online</span>
          </>
        ) : (
          <>
            <WifiOffIcon size={16}/>
            <span className="font-medium hidden md:inline ml-1.5">Offline</span>
          </>
        )}
      </div>
    </div>
  );
};
